
import React from 'react';
import { Bot, MoreHorizontal, Play, Settings, BarChart3 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface AIAgentProps {
  agent: {
    id: string;
    name: string;
    role: string;
    avatar: string;
    department: string;
    capability: string;
  };
}

const AIAgentCard: React.FC<AIAgentProps> = ({ agent }) => {
  return (
    <Card className="overflow-hidden transition-all duration-300 hover:shadow-md border-primary/10 h-full flex flex-col">
      <CardHeader className="pb-2">
        <div className="flex items-center space-x-4">
          <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
            {agent.avatar ? (
              <img 
                src={agent.avatar} 
                alt={agent.name} 
                className="h-12 w-12 rounded-full object-cover" 
              />
            ) : (
              <Bot className="h-6 w-6 text-primary" />
            )}
          </div>
          <div className="space-y-1">
            <h3 className="font-medium text-base flex items-center">
              {agent.name}
              <span className="ml-2 bg-primary/10 text-primary text-xs px-2 py-0.5 rounded-full">AI</span>
            </h3>
            <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
              <p className="text-sm text-muted-foreground">{agent.role}</p>
              <div className="hidden sm:block text-muted-foreground">•</div>
              <span className="text-xs">{agent.department}</span>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pb-2 flex-grow">
        <p className="text-sm text-muted-foreground line-clamp-3">
          {agent.capability}
        </p>
        <div className="mt-3 space-y-2">
          <div className="flex items-center text-sm gap-2">
            <BarChart3 className="h-4 w-4 text-muted-foreground" />
            <span className="text-sm">Performance metrics</span>
          </div>
        </div>
      </CardContent>
      <CardFooter className="pt-0 flex gap-2">
        <Button variant="outline" size="sm" className="flex-1 gap-1">
          <Play className="h-3 w-3" />
          Run
        </Button>
        <Button variant="outline" size="sm" className="flex-1 gap-1">
          <Settings className="h-3 w-3" />
          Configure
        </Button>
        <Button variant="outline" size="sm" className="w-10 px-0">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </CardFooter>
    </Card>
  );
};

export default AIAgentCard;
